// extracted by mini-css-extract-plugin
export var statItem = "_ce-1";
export var statsRow = "_ce-0";